// The tabs of the normalization detail page, in display order. Shared by the
// page and by the route's `validateSearch`, which accepts `?tab=` from this list.
export const NORMALIZATION_TABS = ['overview', 'pipeline', 'test'] as const

export type NormalizationTab = (typeof NORMALIZATION_TABS)[number]
